import { render, staticRenderFns } from "./RelatorioDREGerencialTable.vue?vue&type=template&id=d97174ae&scoped=true"
import script from "./RelatorioDREGerencialTable.vue?vue&type=script&lang=js"
export * from "./RelatorioDREGerencialTable.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDREGerencialTable.vue?vue&type=style&index=0&id=d97174ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97174ae",
  null
  
)

export default component.exports